<script lang="ts" setup>
import RFirstScreen from '~/components/organs/home/FirstScreen.vue'
import RSecondaryScreen from '~/components/organs/home/SecondaryScreen.vue'
import RReviews from '~/components/organs/home/Reviews.vue'
import RAdvantages from '~/components/organs/home/Advantages.vue'
import RVideo from '~/components/organs/home/Video.vue'
import { DefaultImage } from '~/static/enums/image/default-images'
import { BackgroundRemovalStatus } from '~/static/enums/image/background-removal-status'
import { useRemovalBackgroundStore } from '~/store/removal-background'

const imageStore = useRemovalBackgroundStore()

const makeInfigraficForImage = (file: File): void => {
  imageStore.loadImageWithBackgroundRemoved(file)
  useRouter().push('/file')
}

const makeInfigraficForDefaultImage = (image: DefaultImage) => {
  imageStore.originalName = image.name
  imageStore.imageUrl = image.url
  imageStore.imageWithoutBackgroundUrl = image.backRemovedUrl
  imageStore.backgroundRemovalStatus = BackgroundRemovalStatus.Completed
  useRouter().push('/file')
}

</script>

<template>
  <div class="content-page">
    <RFirstScreen
      @image-selected="makeInfigraficForImage"
      @default-image-selected="makeInfigraficForDefaultImage"
    />
    <RSecondaryScreen
      @image-selected="makeInfigraficForImage"
    />
    <RReviews />
    <RAdvantages
      @image-selected="makeInfigraficForImage"
    />
    <RVideo
      @image-selected="makeInfigraficForImage"
    />
  </div>
</template>

<style lang="scss" scoped>
.content-page {
  font-size: rem(16px);
}
</style>
